import { css } from "@emotion/core";
import { color, fontSizes, fonts } from "../../theme/Theme";

export const currentBankAccountDetailsStyles = css({
  ".title": {
    fontSize: fontSizes.title,
    fontFamily: fonts.bold,
    color: color.fiord
  },
  ".submit-button": {
    textAlign: "right"
  },
  ".input-field": {
    maxWidth: "26rem"
  },
  ".ant-input": {
    padding: "0rem"
  },
  ".loan-acceptance": {
    fontWeight: "bold",
    span: {
      color: color.green
    }
  }
});

export const currentBankAccountDetailsModalStyles = css({
  ".ant-modal-header": {
    backgroundColor: color.primary
  },
  ".anticon-check-circle ": {
    fontSize: fontSizes.tickIcon,
    color: color.primary
  },
  ".check-icon": {
    textAlign: "center"
  },
  ".modal-content": {
    fontSize: fontSizes.cardLabel,
    fontFamily: fonts.bold,
    textAlign: "center"
  }
});
